export default {
  replacementOrderFree: {
    id: 'express_replacement_payment_replacement_order_free',
    defaultMessage: 'Free',
  },
  replacementOrderShipping: {
    id: 'express_replacement_payment_replacement_order_shipping',
    defaultMessage: 'Shipping',
  },
  replacementOrderDeliveryRange: {
    id: 'express_replacement_payment_replacement_order_delivery_range',
    defaultMessage: 'Get it by {min} - {max}',
  },
}
